exports = module.exports = require("../../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lt-error-reference{margin-top:12px}.lt-error-reference__line{margin:0;font-size:12px;line-height:1.4;color:#4a5f54;user-select:text;word-break:break-word}.lt-error-reference__text{user-select:all}.lt-error-reference__copy{margin-left:8px;padding:0 4px;min-height:24px;border:0;background:rgba(0,0,0,0);color:#0e7a4b;font-size:12px;font-weight:600;text-decoration:underline;cursor:pointer}.lt-error-reference__contact{margin-top:8px;padding:8px 12px;min-height:40px;border:1px solid #dbe5df;border-radius:4px;background:rgba(0,0,0,0);color:#0b2318;font-size:14px;font-weight:600;cursor:pointer}.lt-error-reference__copy:focus-visible,.lt-error-reference__contact:focus-visible{outline:2px solid #0e7a4b;outline-offset:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/fehin/LunchteamClaude/lunch-team-client-checkout-msg/node_modules/css-loader!/Users/fehin/LunchteamClaude/lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./src/components/UI/ErrorReference/errorReference.scss
// module id = 673
// module chunks = 7